var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 80,
    viewBox: "0 0 74 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.7428 61.8182H4.28828C2.68828 61.8182 1.2701 60.7636 0.797373 59.2364C0.324646 57.7091 0.942827 56.0364 2.25192 55.1636C2.28828 55.1636 11.5246 48.2545 11.5246 25.4545C11.561 11.4182 22.9792 0 37.0156 0C51.0519 0 62.4701 11.4182 62.4701 25.4545C62.4701 48.2545 71.7065 55.1273 71.8156 55.2C73.0883 56.1091 73.6701 57.7818 73.1974 59.2727C72.7246 60.7636 71.3428 61.8182 69.7428 61.8182ZM12.0701 54.5455H61.961C58.6883 49.1636 55.1974 40 55.1974 25.4545C55.1974 15.4182 47.0519 7.27273 37.0156 7.27273C26.9792 7.27273 18.8337 15.4182 18.8337 25.4545C18.8337 40 15.3792 49.1636 12.0701 54.5455Z",
    fill: "#20262D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9792 80C35.1246 80 33.2337 79.5273 31.5246 78.5455C29.8883 77.6 28.5065 76.2182 27.561 74.5818C26.5428 72.8364 27.161 70.6182 28.8701 69.6C30.6156 68.5818 32.8337 69.2 33.8519 70.9091C34.1792 71.4545 34.6156 71.9273 35.161 72.2182C36.9065 73.2364 39.1246 72.6182 40.1428 70.9091C41.161 69.1636 43.3792 68.5818 45.1246 69.6C46.8701 70.6182 47.4519 72.8364 46.4337 74.5818C44.3974 78.0727 40.761 80 36.9792 80Z",
    fill: "#20262D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.79e83a15081bc8e99076f88d579ed5d7.svg";
export { ForwardRef as ReactComponent };